export const notification_type_tr = {
  game_new: "Yeni Oyun",
  game_updated: "Güncellenen Oyun",
};
